// Banner — full-width inline notice. Used for system-level
// announcements. Severity tints are derived from tokens.css.

const TINTS = {
  info:     { bg: 'rgba(0,212,255,0.06)',  border: 'rgba(0,212,255,0.20)',  color: 'var(--olv-cyan)'   },
  success:  { bg: 'rgba(0,230,138,0.06)',  border: 'rgba(0,230,138,0.20)',  color: 'var(--olv-green)'  },
  warning:  { bg: 'rgba(255,178,36,0.06)', border: 'rgba(255,178,36,0.20)', color: 'var(--olv-amber)'  },
  critical: { bg: 'rgba(255,59,92,0.06)',  border: 'rgba(255,59,92,0.22)',  color: 'var(--olv-red)'    },
}

export default function Banner({ severity = 'info', title, children, onDismiss }) {
  const t = TINTS[severity] || TINTS.info
  return (
    <div
      role="status"
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        borderRadius: 'var(--olv-radius-panel)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        fontFamily: 'var(--font-body)',
      }}
    >
      <div style={{ flex: 1 }}>
        {title && (
          <div
            style={{
              fontSize: 11,
              color: t.color,
              fontFamily: 'var(--font-mono)',
              letterSpacing: '0.10em',
              textTransform: 'uppercase',
              marginBottom: 4,
            }}
          >
            {title}
          </div>
        )}
        {children && (
          <div style={{ fontSize: 12, color: 'var(--olv-text-secondary)' }}>{children}</div>
        )}
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--olv-text-tertiary)',
            cursor: 'pointer',
            fontSize: 16,
            lineHeight: 1,
          }}
        >
          ×
        </button>
      )}
    </div>
  )
}
